// https://github.com/iliakan/detect-node
const isServer =
  typeof process !== 'undefined' &&
  Object.prototype.toString.call(process) === '[object process]';

export { isServer };
